// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n[data-v-5643f5c2] .dx-menu-item-content {\r\n    display: flex;\r\n    align-items: center;\n}\n[data-v-5643f5c2] .dx-row-removed > td {\r\n    background-color: white;\r\n    text-decoration: line-through;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
